import { HttpClient } from 'shared/libs/http';
import {
   DeactivatesliderResponse,
   SelectForSliderResponse,
   UpdateEmployerOrderDto,
   UpdateEmployerOrderResponse,
} from './types';

export class AdminApiService {
   public static async selectforslider<TDto extends null>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<SelectForSliderResponse>('/admin/users/selectforslider', dto, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }

   public static async updateemployerorder<TDto extends UpdateEmployerOrderDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<UpdateEmployerOrderResponse>(
         '/admin/users/updateemployerorder',
         dto,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async deactivateslider<TDto extends { slug: string }>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<DeactivatesliderResponse>(
         `/admin/users/deactivateslider/${dto.slug}`,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async activateslider<TDto extends { slug: string }>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<UpdateEmployerOrderResponse>(
         `admin/users/deactivateslider/${dto.slug}`,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }
}
